import { Component, SimpleChanges, OnChanges, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Output, EventEmitter, Pipe, PipeTransform } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors, FormControl, FormGroup, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { CustomerService } from '../../../services/customer.service';
import { OrdersService } from '../../services/orders.service';
import { InventoryService } from '../../services/inventory.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { UsersService } from '../../services/users.service';
import { DispatchService } from '../../services/dispatch.service';
import { OmsService } from '../../services/oms.service';
import { CouponService } from 'app/services/coupon.service';
import { MatTableDataSource } from '@angular/material/table';


@Component({
	selector: 'app-coupons',
	templateUrl: './coupons.component.html',
	styleUrls: ['./coupons.component.scss']
})
export class CouponsComponent implements OnInit {
	@Input() customer: any = false;
	@Output() addCoupon = new EventEmitter < any > ();

	@ViewChild('couponModal') couponformRef: ElementRef;
	couponForm: UntypedFormGroup;
	couponCategoryInput: string;
	couponProductInput: string;

	defaultAddCoupon: any;
	allCoupons: any;
	categories: Object;
	catcontrols: any[] = [];
	prodsReady = false;
	prodSearch: { datasource: any; displayedColumns: string[]; };
	submitting = false;
	modename: any = 'Add ';

	constructor(private dispatchService: DispatchService, private inventoryService: InventoryService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, public omsService: OmsService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService, private couponService: CouponService) {}

	ngOnInit(): void {
		
		this.getAllCoupons();
	}

	getTimeFormat(): string {
		const cTime = new Date();

		const month = (((cTime.getUTCMonth() + 1) < 10) ? '0' : '') + (cTime.getUTCMonth() + 1);
		const day = ((cTime.getUTCDate() < 10) ? '0' : '') + cTime.getUTCDate();
		const year = cTime.getUTCFullYear();

		return year + '/' + month + '/' + day;
	}

	getAllCoupons() {
		(async () => this.couponService.getAllCoupons().subscribe(async (result) => {
			this.allCoupons = result;
		}))();
	}

	deleteCoupon(coupon: Object = {}) {
		if (coupon.hasOwnProperty('coupon_id') && confirm('Would you like to delete this coupon?')) {
			this.couponService.deleteCoupon({ selected: [coupon['coupon_id']] }).subscribe(result => {
				this.getAllCoupons();
				alert(`Coupon with ID ${coupon['coupon_id']} has been deleted`);
			})
		}
	}

	saveCouponListing(form: string, listing: string, item: any) {
		const input = item;

		if (input.length < 1) {
			return;
		}

		this[form].value[listing].push(input);
	}

	removeCouponListing(form: string, listing: string, item: any) {
		if (item.length < 1) {
			return;
		}

		this[form].value[listing] = this[form].value[listing].filter((entry: any) => entry != item)
	}

	addCouponMenu() {
		this.couponForm = this.fb.group({
			coupon_id: ['',[]],
			name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(120)]],
			code: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
			type: ['1'],
			coupon_stockid: [''],
			discount: ['', [Validators.required, Validators.minLength(1)]],
			total: ['1'],
			logged: ['1'],
			shipping: ['1'],
			date_added: [this.getTimeFormat()],
			date_end: [this.getTimeFormat()],
			date_start: [this.getTimeFormat()],
			uses_total: ['1', [Validators.required, Validators.minLength(1)]],
			uses_customer: ['0', [Validators.required, Validators.minLength(1)]],
			status: ['1'],
			taxable: ['0'],
			stackable: ['0'],
			coupon_product: [[]],
			top: ['0'], //?, required in DB insertion
			toptext: [''], //?, required in DB insertion
		});
		this.modename = 'Add ';
		this.modalService.open(this.couponformRef, { ariaLabelledBy: 'model-title', size: 'x1' }).result.then(result => {}, reason => {})
	}

	deleteItem(item: any){
	let productlist = this.couponForm.get('coupon_product').value;
	const index = productlist.indexOf(item);
			if (index > -1) {
				productlist.splice(index, 1);
				this.couponForm.get('coupon_product').setValue(productlist);
			}
	}
	saveOrEditCoupon(){
	
		if(this.couponForm.get('coupon_id').value !== null){
		this.saveEditCoupon();
		} else {
		this.saveCoupon();
		}
	
	}
	saveCoupon() {
		if (!this.couponForm.valid) {
			alert('Coupon form is invalid');

			return;
		}

		this.submitting = true;

		//Convert "Enabled" to "1", "Disabled" to "0"
		const convertToBool = (...inputs: string[]): void => {
			for (let i = 0; i < inputs.length; ++i) {
				form[inputs[i]] = (form[inputs[i]] == 'Enabled') ? '1' : '0';
			}
		}

		const form = Object.assign({}, this.couponForm.value);
		form['coupon_category'] = this.catcontrols.filter((i) => i.control.value == true).map((i) => i.id);
		form['type'] = (form['type'] == 'Percent') ? '1' : '0';
		convertToBool('logged', 'shipping', 'status', 'taxable', 'stackable', 'top');


		this.couponService.addCoupon(form).subscribe(result => {
			this.submitting = false;
			if(result['status'] == 'error'){
				alert(result['message']);
			}else{
				this.getAllCoupons();
				this.modalService.dismissAll();
			}
		})
	}

	saveEditCoupon() {

		if (!this.couponForm.valid) {
			alert('Coupon form is invalid');

			return;
		}

		this.submitting = true;


		//Convert "Enabled" to "1", "Disabled" to "0"
		const convertToBool = (...inputs: string[]): void => {
			for (let i = 0; i < inputs.length; ++i) {
				form[inputs[i]] = (form[inputs[i]] == 'Enabled') ? '1' : '0';
			}
		}

		const form = Object.assign({}, this.couponForm.value);

		form['coupon_category'] = this.catcontrols.filter((i) => i.control.value == true).map((i) => i.id);
		form['type'] = (form['type'] == 'Percent') ? '1' : '0';

		convertToBool('logged', 'shipping', 'status', 'taxable', 'stackable', 'top');


		this.couponService.editCoupon(form).subscribe((result) => {
			this.submitting = false;
			if(result['status'] == 'error'){
				alert(result['message']);
			}else{
				this.getAllCoupons();
				this.modalService.dismissAll();
			}
		})
	}

	/**
	 * Insert a coupon into the edit coupon form, and open the edit menu
	 * @param coupon - Coupon to remove
	 */
	editCoupon(coupon: any) {
	this.modename = 'Edit ';
		/*const form = Object.assign({}, coupon);
		console.log(coupon);

		const convertFromBool = (...inputs: string[]): void => {
			for (let i = 0; i < inputs.length; ++i) {
				form[inputs[i]] = (form[inputs[i]] == '1') ? 'Enabled' : 'Disabled';
			}
		}

		form['type'] = (form['type'] == '1') ? 'Percent' : 'Amount';
		convertFromBool('logged', 'shipping', 'status', 'taxable', 'stackable', 'top');

		if(form['coupon_category'].length > 0){
			form['coupon_category'].forEach(activeCat => {
				this.catcontrols.map((i) => {
					if(i.id == activeCat.category_id){
						i.control.setValue(true);
					}
				})
			});
		}else{
			this.catcontrols.map((i) => i.control.setValue(false));
		}*/
		
		this.couponForm = this.fb.group({
			coupon_id: [coupon.coupon_id],
			name: [coupon.name, [Validators.required, Validators.minLength(3), Validators.maxLength(120)]],
			code: [coupon.code, [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
			type: [coupon.type],
			coupon_stockid: [coupon.stockid],
			discount: [coupon.discount, [Validators.required, Validators.minLength(1)]],
			total: [coupon.total],
			logged: [coupon.logged],
			shipping: [coupon.shipping],
			date_added: [coupon.date_added],
			date_end: [coupon.date_end],
			date_start: [coupon.date_start],
			uses_total: [coupon.uses_total, [Validators.required, Validators.minLength(1)]],
			uses_customer: [coupon.uses_customer, [Validators.required, Validators.minLength(1)]],
			status: [coupon.status],
			taxable: [coupon.taxable],
			stackable: [coupon.stackable],
			coupon_product: [coupon.coupon_product],
			top: [coupon.top], //?, required in DB insertion
			toptext: [coupon.toptext], //?, required in DB insertion
		});


		//const category: FormArray = new FormArray([...form['coupon_category'].map(item => new FormControl(item['category_id']))]);
		//const product: FormArray = new FormArray([...form['coupon_product'].map(item => new FormControl(item['product_id']))]);



		//form['coupon_category'] = [];
		//form['coupon_product'] = [];

		//this.couponForm.patchValue(form)
		//this.couponForm.setControl('coupon_category', category);
		//this.editcouponForm.setControl('coupon_product', product);
		
		console.log(this.couponForm);
		this.modalService.open(this.couponformRef, { ariaLabelledBy: 'modal-title', size: 'xxl' }).result.then(
			result => {},
			reason => {}
		)
	}

	
	addItems(list: any){
	
		list.forEach(i => {
			const newitem = { stockid: i.stockid, description: i.description };
			this.couponForm.get('coupon_product').value.push(newitem);
		});
	}
	productSearch(input: any){
		this.prodsReady = false;
		const data = {
			stockid: input.target.value
		}
		this.inventoryService.itemSearch(data).subscribe((res) => {
			this.prodSearch = {
				datasource: new MatTableDataSource(res),
				displayedColumns: ['stockid']
			}
			this.prodsReady = true;
		})
	}
}
